import { Link, useLocation } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { track } from "@/lib/forms";

const HIDDEN_PREFIXES = ["/book", "/privacy", "/terms", "/cookies", "/thank-you", "/unsubscribe"];

export default function MobileBookingBar() {
  const { pathname } = useLocation();
  if (HIDDEN_PREFIXES.some((p) => pathname.startsWith(p))) return null;

  return (
    <div
      className="lg:hidden fixed bottom-0 inset-x-0 z-40 px-3 pt-2 pointer-events-none"
      style={{ paddingBottom: "calc(env(safe-area-inset-bottom, 0px) + 8px)" }}
      aria-label="Quick booking"
    >
      <Link
        to="/book"
        onClick={() => track("cta_sticky_mobile_book_click", { from: pathname })}
        data-cta="book-workflow-diagnosis"
        className="pointer-events-auto flex items-center justify-center gap-2 w-full h-12 rounded-full bg-primary text-primary-foreground font-semibold text-[15px] shadow-[0_8px_28px_rgba(8,32,72,0.22)]"
      >
        Book a workflow diagnosis <ArrowRight className="h-4 w-4" />
      </Link>
    </div>
  );
}
